import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../../security/security.service';

@Injectable({
    providedIn: 'root'
})
export class KSolveAdminGuard implements CanActivate {

    constructor(private router: Router, private securityService: SecurityService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        // Check if user is logged in
        if (!this.securityService.loggedIn()) {
            this.router.navigate(['/login']);
            return false;
        }

        // Check if user is ksolve-admin
        const user = localStorage.getItem('User');
        if (user === 'ksolve-admin') {
            return true;
        }

        // Redirect to home if not authorized
        this.router.navigate(['/reception']);
        return false;
    }
}
